import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './calendar.types';

export const calendarSelectors = {
  ...generateResourceSelectors<types.ICalendar>((state) => state.resource.calendar),
};
